import React, { useState, useEffect } from "react";
import { NavBar, Footer } from "../../components";
import { db } from "../../config/firebase";
import { ref, onValue } from "firebase/database";
import "./wartajemaat.scss";
import { Document, Page, pdfjs } from "react-pdf";

// Worker react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

const WartaJemaat = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showPdf, setShowPdf] = useState(false);
  const [pdfType, setPdfType] = useState(null);

  const [pdfSources, setPdfSources] = useState({
    warta: null,
    tata: null,
  });
  const [isLoadingLinks, setIsLoadingLinks] = useState(true);
  const [fadeOutLoader, setFadeOutLoader] = useState(false);

  // Ambil link PDF dari Firebase
  useEffect(() => {
    const linksRef = ref(db, "pdf_links");
    const unsubscribe = onValue(
      linksRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) {
          setPdfSources({
            warta: data.warta || null,
            tata: data.tata || null,
          });
        }
        setFadeOutLoader(true);
        setTimeout(() => setIsLoadingLinks(false), 600);
      },
      (error) => {
        console.error("Gagal membaca link PDF:", error);
        setFadeOutLoader(true);
        setTimeout(() => setIsLoadingLinks(false), 600);
      }
    );

    return () => unsubscribe();
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const goToPrevPage = () => setPageNumber((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setPageNumber((p) => Math.min(p + 1, numPages));

  const handleCardClick = (type) => {
    if (pdfSources[type]) {
      setPdfType(type);
      setShowPdf(true);
      setLoading(true);
      setPageNumber(1);
      document.body.style.overflow = "hidden"; // 🔒 mencegah scroll di background
    } else {
      alert("Link PDF belum tersedia atau gagal dimuat. Mohon coba lagi nanti.");
    }
  };

  const handleBack = () => {
    setShowPdf(false);
    setNumPages(null);
    setPdfType(null);
    document.body.style.overflow = "auto"; // 🔓 aktifkan scroll kembali
  };

  const isWartaReady = pdfSources.warta !== null;
  const isTataReady = pdfSources.tata !== null;

  return (
    <div className="warta-jemaat-page">
      <NavBar />

      {/* === LOADER === */}
      {isLoadingLinks && (
        <div
          className={`fullscreen-loader ${
            fadeOutLoader ? "fade-out" : "fade-in"
          }`}
        >
          <div className="spinner"></div>
          <p>Memuat Link Dokumen...</p>
        </div>
      )}

      <main className={`warta-content ${isLoadingLinks ? "blurred" : ""}`}>
        {!showPdf && !isLoadingLinks && (
          <section className="header-card-section fade-in">
            {/* CARD WARTA */}
            <div
              className={`card-content ${
                isWartaReady ? "clickable" : "disabled"
              }`}
              onClick={() => handleCardClick("warta")}
            >
              <div className="card-image-wrap warta">
                <h1 className="title-overlay">
                  WARTA JEMAAT <br /> GMIM GENESARET PATETEN
                </h1>
              </div>
              <div className="card-description">
                <p className="small-text">Pengumuman Mingguan</p>
                <h2>Warta Jemaat</h2>
                <p className="description-text">
                  Warta atau pengumuman teknis seputar Jemaat Genesaret Pateten
                  setiap minggunya dapat anda akses secara online pada halaman ini.
                </p>
                {!isWartaReady && (
                  <p className="status-overlay">File belum tersedia</p>
                )}
              </div>
            </div>

            {/* CARD TATA */}
            <div
              className={`card-content ${
                isTataReady ? "clickable" : "disabled"
              }`}
              onClick={() => handleCardClick("tata")}
            >
              <div className="card-image-wrap tata">
                <h1 className="title-overlay">
                  TATA IBADAH <br /> GMIM GENESARET PATETEN
                </h1>
              </div>
              <div className="card-description">
                <p className="small-text">Tata Ibadah Setiap Minggu</p>
                <h2>Tata Ibadah Minggu</h2>
                <p className="description-text">
                  Tata ibadah setiap minggu berjalan pada jemaat Genesaret Pateten
                  dapat anda akses secara online pada halaman ini.
                </p>
                {!isTataReady && (
                  <p className="status-overlay">File belum tersedia</p>
                )}
              </div>
            </div>
          </section>
        )}

        {/* === FULLSCREEN PDF VIEWER === */}
        {showPdf && (
          <div className="pdf-overlay fade-in">
            <div className="pdf-toolbar">
              <button className="back-btn" onClick={handleBack}>
                ← Kembali
              </button>
              <span className="pdf-title">
                {pdfType === "warta" ? "Warta Jemaat" : "Tata Ibadah"}
              </span>
              <div className="pdf-controls">
                <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
                  &lt;
                </button>
                <span>
                  {pageNumber}/{numPages || 1}
                </span>
                <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
                  &gt;
                </button>
              </div>
            </div>

            {loading && (
              <div className="pdf-loader">
                <div className="spinner"></div>
                <p>Memuat dokumen...</p>
              </div>
            )}

            <div className="pdf-fullscreen-view">
              <Document
                file={pdfSources[pdfType]}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(err) => console.error("Gagal memuat PDF:", err)}
              >
                <Page
                  pageNumber={pageNumber}
                  width={window.innerWidth * 0.9}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default WartaJemaat;
